module.exports = __webpack_public_path__ + "static/media/DSC_6672_HDR.0a0f53ff.jpg";